module.exports = __webpack_public_path__ + "static/media/up_white.4dff7856.svg";